import { render, staticRenderFns } from "./DataSourceForm.vue?vue&type=template&id=0eb07f2f&scoped=true&"
import script from "./DataSourceForm.vue?vue&type=script&lang=ts&"
export * from "./DataSourceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb07f2f",
  null
  
)

export default component.exports